import React from "react";
import styles from "./gateways-list.module.scss";
import { GatewaysListBody } from "@src/components/molecules/gateways-list-body/gateways-list-body";
import { GatewayWithMachinesViewStateTypes } from "@src/types/gateways-with-machines";
export interface GatewaysListPropTypes {
  data: GatewayWithMachinesViewStateTypes[];
  description: string;
  state: "Connected" | "Disconnected";
}

const cssClassName = "gateways-list";

export const GatewaysList = ({ data, description }: GatewaysListPropTypes) => {
  return (
    <table className={styles[cssClassName]}>
      <tbody className={styles[`${cssClassName}__body`]}>
        <GatewaysListBody data={data} description={description} />
      </tbody>
    </table>
  );
};
